import { Action } from 'redux';
import { LineItemKey } from '../api';

export const SELECT_ALL = 'SELECT_ALL';
export const SELECT_ONE = 'SELECT_ONE';
export const SELECT_MULTIPLE = 'SELECT_MULTIPLE';
export const DESELECT_ALL = 'DESELECT_ALL';
export const DESELECT_ONE = 'DESELECT_ONE';
export const DESELECT_MULTIPLE = 'DESELECT_MULTIPLE';
export const SET_SELECTION_MODE = 'SET_SELECTION_MODE';

export type SelectAll = {
    type: typeof SELECT_ALL;
    payload: number;
};

export type ProductSelectionPayload = {
    count?: number;
    productId: LineItemKey;
};

export type MultiProductSelectionPayload = {
    count?: number;
    productIds: Array<LineItemKey>;
};

export type SelectOne = {
    type: typeof SELECT_ONE;
    payload: ProductSelectionPayload;
};

export type SelectMulitple = {
    type: typeof SELECT_MULTIPLE;
    payload: MultiProductSelectionPayload;
};

export type DeselectAll = Action<typeof DESELECT_ALL>;

export type DeselectMultiple = {
    type: typeof DESELECT_MULTIPLE;
    payload: MultiProductSelectionPayload;
};

export type DeselectOne = {
    type: typeof DESELECT_ONE;
    payload: ProductSelectionPayload;
};

export type SetSelectionMode = {
    type: typeof SET_SELECTION_MODE;
    payload: boolean;
};

export type ProductSelectionAction =
    | SelectAll
    | SelectOne
    | SelectMulitple
    | DeselectAll
    | DeselectMultiple
    | DeselectOne
    | SetSelectionMode;
